import React, { useMemo } from 'react'
import { Form } from 'components/atoms'
import { Formik, Field } from 'formik';
import { FieldImageGalleryUpload } from 'components/molecules';
import * as Yup from 'yup';
import { generatePortalImageSrc } from 'services/generators'
import PropTypes from 'prop-types';

const ImageSchema = Yup.object().shape({
  data: Yup.object({
    url: Yup.string(),
    alt: Yup.string(),
    title: Yup.string()
  }),
});

const defaultData = {
  url: '',
  alt: '',
  title: '',
  isLocal: false,
}

const ImageEditor = ({ initialProps, onChange }) => {
  const initialValues = useMemo(() => {
    if ('data' in initialProps) {
      return {
        data: {
          ...initialProps,
          ...defaultData,
          url: initialProps.data && initialProps.data.url ? generatePortalImageSrc(initialProps.data.url) : '',
          alt: initialProps.data && initialProps.data.alt ? initialProps.data.alt : 'Imagem de destaque'
        }
      }
    }
    return {
      data: defaultData
    }
  }, [initialProps])

  const handleFormChange = (newValues) => {
    const newProps = {
      ...initialProps,
      ...newValues,
    };
    const isValid = ImageSchema.isValidSync(newValues)
    if (isValid) onChange(newProps)
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ImageSchema}
      validate={handleFormChange}
    >
      <Form modifiers={['stretch']}>
        <Field
          title="Imagem"
          name="data"
          placeholder="Imagem"
          info="Imagem de partilha."
          component={FieldImageGalleryUpload}
        />
      </Form>
    </Formik>
  )
}

ImageEditor.propTypes = {
  initialProps: PropTypes.shape({
    data: PropTypes.shape({
      url: PropTypes.string
    })
  }).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ImageEditor
